const mapStateToProps = (state) => {
    const {

        service:{
            Directory:{
                updateShortDirectory,
            }={},

        }={}
    } = state;
    return {
        updateShortDirectory,
    }
}

export default mapStateToProps;